import { render, staticRenderFns } from "./VehicleTypeIcon.vue?vue&type=template&id=725e77c1&scoped=true&"
import script from "./VehicleTypeIcon.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypeIcon.vue?vue&type=style&index=0&id=725e77c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e77c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VChip,VIcon})
